<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form *ngIf="data.status === 'Add'" [formGroup]="scheduleForm"
            class="row d-flex align-items-center justify-content-center">
            <div class="col-12 schedule-form">
                <div class="row">
                    <div class="col-12 mb-1">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-12">
                                <div class="row">
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Employee Name</mat-label>
                                        <input matInput formControlName="employeeName" placeholder="employeeName"
                                            disabled>
                                    </mat-form-field>
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Payroll Period</mat-label>
                                        <input matInput formControlName="payrollPeriod" placeholder="payrollPeriod"
                                            disabled>
                                    </mat-form-field>
                                </div>
                                <div class="row">
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Day of Week</mat-label>
                                        <mat-select formControlName="weekDay">
                                            <mat-option *ngFor="let day of weekdays" [value]="day.value">{{ day.name
                                                }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div class="col-lg-6 checkbox-container">
                                        <mat-checkbox formControlName="isRestDay">Rest Day</mat-checkbox>
                                        <mat-checkbox formControlName="isCustomWorkday">Custom Workday</mat-checkbox>
                                    </div>
                                </div>
                                <div class="row" *ngIf="scheduleForm.get('isCustomWorkday')?.value">
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Custom Workday Date:</mat-label>
                                        <input matInput [matDatepicker]="customWorkday"
                                            formControlName="customWorkdayDate" required>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                            [for]="customWorkday"></mat-datepicker-toggle>
                                        <mat-datepicker #customWorkday></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="row">
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Valid From:</mat-label>
                                        <input matInput [matDatepicker]="picker" formControlName="validFrom" required>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                            [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="col-lg-6" appearance="outline">
                                        <mat-label>Valid To:</mat-label>
                                        <input matInput [matDatepicker]="picker2" formControlName="validTo" required>
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                            [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker1.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker1" formControlName="rampTime1"
                                            placeholder="Time 1">
                                        <ngx-material-timepicker #timepicker1></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker2.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker2" formControlName="rampTime2"
                                            placeholder="Time 2">
                                        <ngx-material-timepicker #timepicker2></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker3.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker3" formControlName="rampTime3"
                                            placeholder="Time 3">
                                        <ngx-material-timepicker #timepicker3></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker4.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker4" formControlName="rampTime4"
                                            placeholder="Time 4">
                                        <ngx-material-timepicker #timepicker4></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker5.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker5" formControlName="rampTime5"
                                            placeholder="Time 5">
                                        <ngx-material-timepicker #timepicker5></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                                <div class="form-group row">
                                    <mat-form-field class="example-full-width col-12" appearance="outline">
                                        <mat-icon class="icon" (click)="timepicker6.open()">access_time</mat-icon>
                                        <input matInput [ngxTimepicker]="timepicker6" formControlName="rampTime6"
                                            placeholder="Time 6">
                                        <ngx-material-timepicker #timepicker6></ngx-material-timepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div *ngIf="data.status === 'Delete'">
            {{ data.content }}
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <div *ngIf="!isLoading; else confirmTemplate">
            <button *ngIf="data.confirmText === 'Confirm'" mat-button class="yes-button"
                (click)="onSubmit(scheduleForm)" cdkFocusInitial>{{data.confirmText}}</button>
        </div>
        <ng-template #confirmTemplate>
            <button type="button" mat-button class="yes-button" disabled>
                {{data.confirmText}} <span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
            </button>
        </ng-template>
        <div *ngIf="!isLoadingDelete; else deleteTemplate">
            <button *ngIf="data.confirmText === 'Delete'" mat-button class="delete-button" (click)="deleteSchedule()"
                cdkFocusInitial>{{data.confirmText}}</button>
        </div>
        <ng-template #deleteTemplate>
            <button type="button" mat-button class="delete-button" disabled>
                {{data.confirmText}} <span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>